<div class="px-3 md:px-4 py-3 md:py-4 max-w-[900px] mx-auto">
  <header class="mb-6 flex items-start justify-between gap-3">
    <div class="flex items-start gap-3 min-w-0 flex-1">
      @if (isSmallScreen() && !dialogData && !bottomSheetData) {
        <button
          mat-icon-button
          class="w-10 h-10 rounded-xl bg-white border border-gray-200 shadow-sm flex items-center justify-center text-gray-500 hover:bg-gray-50 transition-colors shrink-0 mt-0.5"
          (click)="sidenavService.toggle()"
          [matTooltip]="(sidenavService.opened() ? 'Global.Close' : 'Global.Open') | translate"
        >
          <mat-icon class="text-[20px]! w-5! h-5!">{{ sidenavService.opened() ? 'left_panel_close' : 'left_panel_open' }}</mat-icon>
        </button>
      }
      <div class="min-w-0 flex-1">
        <h1 class="text-2xl font-bold text-[#111827] mb-1">
          {{ 'MySpace.configuration.ai.title' | translate }}
        </h1>
        <p class="text-[#6b7280] text-sm m-0">{{ 'MySpace.configuration.ai.subtitle' | translate }}</p>
      </div>
    </div>
    @if (!dialogData && !bottomSheetData && authService.isWriter()) {
      @if (!isSmallScreen()) {
        <button mat-flat-button btnType="action" (click)="saveSettings()" [disabled]="loading" class="shrink-0">
          <mat-icon>save</mat-icon>
          {{ 'Global.Save' | translate }}
        </button>
      } @else {
        <button color="primary" mat-mini-fab (click)="saveSettings()" [disabled]="loading" class="shrink-0" [matTooltip]="'Global.Save' | translate">
          <mat-icon>save</mat-icon>
        </button>
      }
    }
  </header>

  @if (dialogData || bottomSheetData) {
    <div class="dialog-button-container">
      <button mat-button (click)="close()" [disabled]="loading">
        {{ 'Global.Close' | translate }}
      </button>
      @if (authService.isWriter()) {
        <button color="primary" mat-flat-button (click)="saveSettings()" [disabled]="loading">
          {{ 'Global.Save' | translate }}
        </button>
      }
    </div>
  }

  <!-- Synthèse vocale -->
  @if (authService.isWriter() && authService.canUseAI()) {
    <div class="settings-card">
      <div class="settings-card-header">
        <h3>{{ 'MySpace.TTSConfigHeader' | translate }}</h3>
        <p>{{ 'MySpace.TTSConfigHeaderDesc' | translate }}</p>
      </div>

      @if (selectedTTSLanguage && audioConfiguration && audioConfiguration[selectedTTSLanguage]) {
        <!-- Voice Language -->
        <div class="settings-row">
          <div class="settings-row__info">
            <h4>{{ 'MySpace.TTSLanguage' | translate }}</h4>
            <p>{{ 'MySpace.TTSLanguageDesc' | translate }}</p>
          </div>
          <div class="settings-row__control text-right min-w-[160px] max-w-[250px]">
            <ui-select [compact]="true" [options]="ttsLanguages" [(ngModel)]="selectedTTSLanguage" (valueChange)="onTTSLanguageChange($event)"></ui-select>
          </div>
        </div>

        <!-- Voice Type -->
        <div class="settings-row">
          <div class="settings-row__info">
            <h4>{{ 'MySpace.TTSVoiceType' | translate }}</h4>
            <p>{{ 'MySpace.TTSVoiceTypeDesc' | translate }}</p>
          </div>
          <div class="settings-row__control text-right min-w-[160px] max-w-[250px]">
            <ui-select [compact]="true" [options]="currentVoiceOptions" [(ngModel)]="audioConfiguration[selectedTTSLanguage].voiceType"></ui-select>
          </div>
        </div>

        <!-- Speed -->
        <div class="settings-row">
          <div class="settings-row__info">
            <h4>{{ 'MySpace.TTSAudioSpeed' | translate }}</h4>
            <p>{{ 'MySpace.TTSAudioSpeedDesc' | translate }}</p>
          </div>
          <div class="settings-row__control flex items-center justify-end gap-2">
            <mat-slider min="0.25" max="4" step="0.01" discrete #ngSpeedSlider class="flex-1">
              <input
                matSliderThumb
                [value]="audioConfiguration[selectedTTSLanguage].speed"
                (input)="onSliderUpdate({ source: speedThumb, parent: ngSpeedSlider, value: speedThumb.value }, 'speed')"
                #speedThumb="matSliderThumb"
              />
            </mat-slider>
            <button mat-icon-button color="primary" (click)="resetSlider('speed')">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>

        <!-- Sample Text -->
        <div class="settings-row items-start">
          <div class="settings-row__info">
            <h4>{{ 'MySpace.SampleText' | translate }}</h4>
            <p>{{ 'MySpace.SampleTextDesc' | translate }}</p>
          </div>
          <div class="settings-row__control">
            <mat-form-field appearance="fill" subscriptSizing="dynamic">
              <textarea matInput [(ngModel)]="sampleText" rows="3"></textarea>
            </mat-form-field>
            <div class="text-right mt-3">
              <button mat-flat-button btnType="action" (click)="generateOrStopSample()" [disabled]="isGeneratingSample">
                @if (isGeneratingSample) {
                  <mat-icon class="mat-icon-spin">progress_activity</mat-icon>
                } @else if (!isPlayingSample) {
                  <mat-icon>volume_up</mat-icon>
                } @else {
                  <mat-icon>stop</mat-icon>
                }

                @if (!isPlayingSample) {
                  <span>{{ 'MySpace.PreviewVoice' | translate }}</span>
                } @else {
                  <span>{{ 'Global.Stop' | translate }}</span>
                }
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Autorisations -->
  <div class="settings-card" id="authorization">
    <div class="settings-card-header settings-card-header--with-action">
      <div class="header-text">
        <h3>{{ 'MySpace.Authorisations' | translate }}</h3>
        <p>{{ 'MySpace.AuthorisationsDesc' | translate }}</p>
      </div>
      <button mat-icon-button class="demo-icon" (click)="showPermissionDemo()" [matTooltip]="'Permissions.ShowDemo' | translate">
        <mat-icon>help_outline</mat-icon>
      </button>
    </div>

    <div class="p-6">
      <!-- Browser settings guidance banner -->
      <div class="permission-guide mb-6">
        <div class="permission-guide__title">
          <span class="material-symbols-rounded permission-guide__icon">lock</span>
          {{ 'Permissions.BrowserSettingsTitle' | translate }}
        </div>
        <ol class="permission-guide__steps">
          <li>{{ 'Permissions.BrowserSettingsStep1' | translate }}</li>
          <li>{{ 'Permissions.BrowserSettingsStep2' | translate }}</li>
          <li>{{ 'Permissions.BrowserSettingsStep3' | translate }}</li>
        </ol>
      </div>
      <!-- Camera -->
      <div class="toggle-card mb-4">
        <div class="toggle-card__info">
          <h4>{{ 'Permissions.Names.Camera' | translate }}</h4>
          <p>{{ 'Permissions.CameraDesc' | translate }}</p>
        </div>
        <div class="toggle-card__control">
          <mat-slide-toggle
            [disabled]="cameras.length > 0"
            [checked]="cameras.length > 0"
            (change)="handleToggle($event, 'camera')"
            [matTooltip]="cameras.length > 0 ? ('Permissions.RevokeGuidance' | translate: { permissionName: ('Permissions.Names.Camera' | translate) }) : null"
            matTooltipPosition="above"
          ></mat-slide-toggle>
        </div>
      </div>

      <!-- Microphone -->
      <div class="toggle-card mb-4">
        <div class="toggle-card__info">
          <h4>{{ 'Permissions.Names.Microphone' | translate }}</h4>
          <p>{{ 'Permissions.MicrophoneDesc' | translate }}</p>
        </div>
        <div class="toggle-card__control">
          <mat-slide-toggle
            [disabled]="microphones.length > 0"
            [checked]="microphones.length > 0"
            (change)="handleToggle($event, 'microphone')"
            [matTooltip]="microphones.length > 0 ? ('Permissions.RevokeGuidance' | translate: { permissionName: ('Permissions.Names.Microphone' | translate) }) : null"
            matTooltipPosition="above"
          ></mat-slide-toggle>
        </div>
      </div>

      <!-- Notifications (Disabled as FCM is bypassed) -->
      <!--
      <div class="toggle-card mb-0">
        <div class="toggle-card__info">
          <h4>{{ 'Permissions.Names.Notifications' | translate }}</h4>
          <p>Recevoir des alertes système, des rappels et des messages importants.</p>
        </div>
        <div class="toggle-card__control">
          <mat-slide-toggle
            [disabled]="areNotificationsPermitted()"
            [checked]="areNotificationsPermitted()"
            (change)="handleToggle($event, 'notifications')"
            [matTooltip]="areNotificationsPermitted() ? ('Permissions.RevokeGuidance' | translate: { permissionName: ('Permissions.Names.Notifications' | translate) }) : null"
            matTooltipPosition="above"
          ></mat-slide-toggle>
        </div>
      </div>
      -->
    </div>
  </div>

  <!-- Accès IA -->
  @if (authService.isAdmin() && authService.userInfo()?.isOwner) {
    <div class="settings-card">
      <div class="settings-card-header">
        <h3>{{ 'MySpace.AiAccess.Title' | translate }}</h3>
        <p>{{ 'MySpace.AiAccess.Description' | translate }}</p>
      </div>

      <div class="settings-row">
        <div class="settings-row__info">
          <h4>{{ 'MySpace.AiAccess.ModeLabel' | translate }}</h4>
          <p>{{ 'MySpace.AiAccess.ModeDescription' | translate }}</p>
        </div>
        <div class="settings-row__control text-right min-w-[160px] max-w-[250px]">
          <ui-select [compact]="true" [options]="aiAccessModeOptions" [(ngModel)]="aiAccessMode"></ui-select>
        </div>
      </div>

      @if (aiAccessMode === 'restricted') {
        <div class="settings-row items-start">
          <div class="settings-row__info">
            <h4>{{ 'MySpace.AiAccess.AllowedUsersLabel' | translate }}</h4>
            <p>{{ 'MySpace.AiAccess.AllowedUsersDescription' | translate }}</p>
          </div>
          <div class="settings-row__control flex-col gap-4">
            <!-- Search to add users -->
            <div class="ai-user-search">
              <mat-form-field appearance="fill" subscriptSizing="dynamic" class="soft-input w-full mb-2">
                <mat-icon matPrefix class="text-[#9ca3af] mr-2">person_search</mat-icon>
                <input
                  matInput
                  [placeholder]="'MySpace.AiAccess.SearchPlaceholder' | translate"
                  [(ngModel)]="aiUserSearchInput"
                  (ngModelChange)="searchAiUsers()"
                  (focus)="openAiUserOverlay()"
                  #aiUserSearchInputRef
                />
                @if (isSearchingAiUsers) {
                  <mat-spinner diameter="18" matSuffix></mat-spinner>
                }
              </mat-form-field>

              <ng-template #aiUserResultsTemplate>
                <div class="ai-user-search__results custom-scrollbar">
                  @if (aiUserSearchResults.length === 0) {
                    <div class="p-4 text-center text-sm text-gray-400 italic">
                      {{ 'ShareMenu.NoResults' | translate }}
                    </div>
                  }
                  @for (user of aiUserSearchResults; track user._id) {
                    <button class="ai-user-search__result" (click)="addAiAccessUser(user)">
                      <div class="flex items-center gap-3">
                        <div class="ai-user-avatar">
                          @if (user.photoURL) {
                            <img [src]="user.photoURL" alt="" class="w-full h-full object-cover" />
                          } @else {
                            <span>{{ (user.fullName || user.email).charAt(0).toUpperCase() }}</span>
                          }
                        </div>
                        <div class="ai-user-search__result-info">
                          <span class="ai-user-search__result-name">{{ user.fullName || user.email }}</span>
                          @if (user.email && user.fullName) {
                            <span class="ai-user-search__result-email">{{ user.email }}</span>
                          }
                        </div>
                      </div>
                      <mat-icon class="text-gray-400 text-[18px]!">add</mat-icon>
                    </button>
                  }
                </div>
              </ng-template>
            </div>

            <!-- Current allowed users -->
            <div class="ai-user-list custom-scrollbar">
              @for (user of aiAccessUsers; track user._id) {
                <div class="ai-user-item">
                  <div class="flex items-center gap-3">
                    <div class="ai-user-avatar">
                      @if (user.photoURL) {
                        <img [src]="user.photoURL" alt="" class="w-full h-full object-cover" (error)="user.photoURL = undefined" />
                      } @else {
                        <span>{{ (user.fullName || user.email).charAt(0).toUpperCase() }}</span>
                      }
                    </div>
                    <div class="ai-user-item__info">
                      <span class="ai-user-item__name">{{ user.fullName || user.email }}</span>
                      @if (user.email && user.fullName) {
                        <span class="ai-user-item__email">{{ user.email }}</span>
                      }
                    </div>
                  </div>
                  <button mat-icon-button (click)="removeAiAccessUser(user.uid)" class="ai-user-item__remove">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              }
              @if (aiAccessUsers.length === 0) {
                <div class="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-[var(--skz-radius-main)] border border-dashed border-gray-200">
                  <mat-icon class="text-gray-300 text-[40px]! h-[40px]! w-[40px]! mb-2">group_off</mat-icon>
                  <p class="text-sm text-gray-400 italic m-0">{{ 'MySpace.AiAccess.NoUsersAdded' | translate }}</p>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- PSTN Settings -->
  @if (authService.isAdmin()) {
    <div class="settings-card">
      <div class="settings-card-header">
        <h3>{{ 'MySpace.PstnSettings' | translate }}</h3>
        <p>{{ 'MySpace.PstnSettingsDesc' | translate }}</p>
      </div>

      <div class="settings-row">
        <div class="settings-row__info">
          <h4>{{ 'MySpace.PstnLanguage' | translate }}</h4>
          <p>{{ 'MySpace.PstnLanguageDesc' | translate }}</p>
        </div>
        <div class="settings-row__control text-right min-w-[160px] max-w-[250px]">
          <ui-select [compact]="true" [options]="pstnLanguages" [(ngModel)]="pstnGreetingLang"></ui-select>
        </div>
      </div>

      <div class="settings-row items-start no-divider">
        <div class="settings-row__info">
          <h4>{{ 'MySpace.PstnGreetingText' | translate }}</h4>
          <p>{{ 'MySpace.PstnGreetingTextDesc' | translate }}</p>
        </div>
        <div class="settings-row__control">
          <mat-form-field appearance="fill" subscriptSizing="dynamic" class="w-full">
            <textarea matInput [(ngModel)]="pstnGreetingText" rows="3" [placeholder]="'MySpace.PstnGreetingPlaceholder' | translate"></textarea>
          </mat-form-field>
        </div>
      </div>

      <!-- Buttons at the card level -->
      <div class="flex items-center justify-end gap-3 px-6 pb-4">
        <button mat-flat-button btnType="neutral" (click)="generateOrStopPstnPreview()" [disabled]="isGeneratingPstnPreview">
          @if (isGeneratingPstnPreview) {
            <mat-icon class="mat-icon-spin">progress_activity</mat-icon>
          } @else if (!isPlayingPstnPreview) {
            <mat-icon>volume_up</mat-icon>
          } @else {
            <mat-icon>stop</mat-icon>
          }

          @if (!isPlayingPstnPreview) {
            <span class="ml-2">{{ 'MySpace.PreviewVoice' | translate }}</span>
          } @else {
            <span class="ml-2">{{ 'Global.Stop' | translate }}</span>
          }
        </button>
        <button mat-icon-button (click)="downloadPstnPreview()" [disabled]="!pstnAudioBlob" [matTooltip]="'Global.Download' | translate">
          <mat-icon>download</mat-icon>
        </button>
        <button mat-flat-button btnType="action" (click)="uploadPstnGreeting()" [disabled]="!pstnAudioBlob || loading">
          {{ 'Global.Save' | translate }}
        </button>
      </div>
    </div>
  }

  <!-- App Settings -->
  @if (authService.isAdmin()) {
    <div class="settings-card">
      <div class="settings-card-header">
        <h3>{{ 'MySpace.AccountDetails' | translate }}</h3>
        <p>{{ 'MySpace.AccountDetailsDesc' | translate }}</p>
      </div>

      <div class="settings-row items-start">
        <div class="settings-row__info">
          <h4>{{ 'MySpace.WorkspaceName' | translate }}</h4>
          <p>{{ 'MySpace.WorkspaceNameDesc' | translate }}</p>
        </div>
        <div class="settings-row__control">
          <ui-input class="float-end" [(ngModel)]="appName" [placeholder]="'MySpace.WorkspaceName' | translate"></ui-input>
        </div>
      </div>

      <!-- Workspace Slug Row -->
      <div class="settings-row items-start no-divider">
        <div class="settings-row__info">
          <h4>{{ 'MySpace.WorkspaceSlug' | translate }}</h4>
          <p>{{ 'MySpace.WorkspaceSlugDesc' | translate }}</p>

          @if (isSubdomainActive && workspaceSlug === initialWorkspaceSlug) {
            <div class="mt-2.5 flex items-start gap-1 text-[11px] text-gray-400 leading-normal">
              <mat-icon class="text-xs! text-gray-400 select-none mt-0.5">info_outline</mat-icon>
              <span>
                {{ 'MySpace.WorkspaceSlugActiveNote' | translate }}
                <a [href]="subdomainLink" target="_blank" class="text-[#5a73c5] hover:underline font-semibold">{{ subdomainLink }}</a>
              </span>
            </div>
          }
        </div>
        <div class="settings-row__control flex items-center justify-end gap-1.5">
          <ui-input
            [compact]="true"
            class="w-[350px]!"
            [(ngModel)]="workspaceSlug"
            (ngModelChange)="slugValidationError = null"
            [formatAsSlug]="true"
            [prefixText]="'https://'"
            [suffixText]="'.' + domainSuffix"
            [placeholder]="'MySpace.WorkspaceSlug' | translate"
          ></ui-input>
        </div>
      </div>

      <!-- Card level footer buttons for Account Details -->
      <div class="flex items-center justify-end gap-3 px-6 pb-4">
        @if (slugValidationError) {
          <span class="text-xs font-semibold text-rose-500 mr-auto leading-tight text-left">
            {{ slugValidationError.startsWith('MySpace.') ? (slugValidationError | translate) : slugValidationError }}
          </span>
        }

        @if (!isSubdomainActive && isDefaultSlug) {
          <button mat-flat-button btnType="action" (click)="activateSlugField()">
            {{ 'MySpace.WorkspaceSlugActivateBtn' | translate }}
          </button>
        } @else {
          <button mat-flat-button btnType="action" (click)="saveWorkspaceSlug()" [disabled]="isSavingSlug || workspaceSlug === initialWorkspaceSlug">
            {{ 'Global.Save' | translate }}
          </button>
        }
      </div>
    </div>
  }

  <!-- Workspace Branding & BYOL -->
  @if (authService.isAdmin()) {
    <div class="settings-card">
      <div class="settings-card-header">
        <h3>{{ 'MySpace.Branding.Title' | translate }}</h3>
        <p>{{ 'MySpace.Branding.Subtitle' | translate }}</p>
      </div>

      <!-- Logo Row -->
      <div class="settings-row items-start no-divider">
        <div class="settings-row__info">
          <h4>{{ 'MySpace.Branding.LogoTitle' | translate }}</h4>
          <p>{{ 'MySpace.Branding.LogoDesc' | translate }}</p>
          <div class="mt-2.5 flex items-start gap-1 text-[11px] text-gray-400 leading-normal">
            <mat-icon class="text-xs! text-gray-400 select-none mt-0.5">info_outline</mat-icon>
            <span>{{ 'MySpace.Branding.DomainRequirementNote' | translate }}</span>
          </div>
        </div>
        <div class="settings-row__control flex flex-col gap-4">
          <input #brandingFileInput type="file" accept="image/svg+xml,image/png,image/jpeg" class="hidden" (change)="onBrandingFileSelected($event)" />

          <!-- Live Mockup Preview Box -->
          <div class="w-full border border-gray-200 rounded-xl p-3.5 bg-gray-50 flex flex-col space-y-2">
            <div class="flex items-center justify-between">
              <span class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">{{ 'MySpace.Branding.LivePreview' | translate }}</span>
              <div class="flex items-center gap-1">
                @if (tenantBrandingService.logoUrl() || brandingSelectedFile()) {
                  <button type="button" mat-icon-button btnType="action-icon" (click)="deleteBrandingLogo()" [disabled]="isSavingBranding">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
                <button mat-icon-button btnType="action-icon" (click)="brandingFileInput.click()" [disabled]="isSavingBranding">
                  <mat-icon>upload_file</mat-icon>
                </button>
              </div>
            </div>

            <!-- Header Mockup Box -->
            <div class="w-full h-12 rounded-lg px-3 flex items-center justify-between transition-colors shadow-inner border border-gray-300/40 bg-white">
              <div class="flex items-center gap-2 h-8 max-w-[150px]">
                @if (brandingPreviewLogoUrl()) {
                  <img
                    [src]="brandingPreviewLogoUrl()"
                    (error)="onBrandingPreviewLogoError($event)"
                    [alt]="'MySpace.Branding.LogoPreviewAlt' | translate"
                    class="w-full h-full object-contain object-left"
                  />
                } @else {
                  <img src="assets/creatives/logo-w70.png" [alt]="'MySpace.Branding.DefaultLogoAlt' | translate" class="w-full h-full object-contain object-left" />
                }
              </div>
              <div class="flex gap-2 items-center opacity-60">
                <div class="w-12 h-2.5 rounded bg-gray-300"></div>
                <div class="w-6 h-6 rounded-full bg-gray-300"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Accent Color Row (Hidden for future implementation) -->
      @if (false) {
        <div class="settings-row items-start">
          <div class="settings-row__info">
            <h4>{{ 'MySpace.Branding.ColorTitle' | translate }}</h4>
            <p>{{ 'MySpace.Branding.ColorDesc' | translate }}</p>
          </div>
          <div class="settings-row__control flex flex-col gap-4">
            <!-- Color Palette Presets -->
            <div class="flex flex-wrap items-center gap-2.5">
              @for (preset of brandingPresetColors; track preset) {
                <button
                  type="button"
                  class="w-8 h-8 rounded-full border-2 transition-all shadow-sm flex items-center justify-center cursor-pointer"
                  [class.border-gray-800]="brandingSelectedColor() === preset"
                  [class.border-transparent]="brandingSelectedColor() !== preset"
                  [class.scale-110]="brandingSelectedColor() === preset"
                  [style.background-color]="preset"
                  (click)="selectBrandingColor(preset)"
                  [matTooltip]="preset"
                >
                  @if (brandingSelectedColor() === preset) {
                    <mat-icon class="text-white text-xs! w-4! h-4!">check</mat-icon>
                  }
                </button>
              }
            </div>

            <!-- Custom Color Input -->
            <div class="flex items-center gap-2 border border-gray-200 rounded-lg px-2.5 py-1 bg-[#f9f9f9] w-fit">
              <input type="color" [value]="brandingSelectedColor()" (input)="onBrandingCustomColorInput($event)" class="w-6 h-6 rounded border-none cursor-pointer bg-transparent p-0" />
              <input
                type="text"
                [value]="brandingSelectedColor()"
                (change)="onBrandingHexTextChange($event)"
                class="w-20 text-xs font-mono text-gray-700 uppercase bg-transparent border-none focus:outline-none"
                placeholder="#5A73C5"
              />
            </div>

            <!-- Button Preview -->
            <div class="p-3 rounded-lg border border-gray-200 bg-gray-50/50 flex items-center justify-between">
              <span class="text-xs text-gray-500 font-medium">{{ 'MySpace.Branding.ButtonPreview' | translate }}</span>
              <button type="button" class="px-4 py-1.5 text-xs font-semibold text-white rounded-lg transition-opacity hover:opacity-90 shadow-sm" [style.background-color]="brandingSelectedColor()">
                {{ 'MySpace.Branding.ActionButton' | translate }}
              </button>
            </div>
          </div>
        </div>
      }

      <!-- Buttons at the card level -->
      <div class="flex items-center justify-end gap-3 px-6 pb-4">
        <button mat-button btnType="neutral" [disabled]="isSavingBranding" (click)="resetBrandingSettings($event)">{{ 'Global.Reset' | translate }}</button>
        <button mat-flat-button btnType="action" [disabled]="isSavingBranding" (click)="saveBrandingSettings()">
          @if (isSavingBranding) {
            <mat-icon class="mat-icon-spin">progress_activity</mat-icon>
          } @else {
            {{ 'Global.Save' | translate }}
          }
        </button>
      </div>
    </div>
  }

  <!-- Custom Domain Settings -->
  @if (authService.isAdmin()) {
    <div class="settings-card custom-domain-card">
      <div class="settings-card-header">
        <div class="header-text">
          <h3>{{ 'MySpace.CustomDomain.Title' | translate }}</h3>
          <p>{{ 'MySpace.CustomDomain.Subtitle' | translate }}</p>
        </div>
      </div>

      <div class="p-4 md:p-5">
        <!-- Active Domain Display -->
        @if (customDomainData?.hasCustomDomain && customDomainData?.status === 'active') {
          <div class="domain-active-row">
            <div class="flex items-center gap-3 min-w-0 flex-1 flex-wrap">
              <span class="domain-active-name">{{ customDomainData?.customDomain }}</span>
              <span class="domain-active-badge">
                <span class="domain-active-badge__dot"></span>
                {{ 'MySpace.CustomDomain.StatusActive' | translate }}
              </span>
            </div>
            <div class="flex items-center gap-1 shrink-0">
              @if (isDeletingDomain) {
                <mat-spinner diameter="18"></mat-spinner>
              } @else {
                <button mat-icon-button (click)="loadCustomDomainInfo()" [matTooltip]="'Global.Refresh' | translate" class="text-gray-400 hover:text-gray-600">
                  <mat-icon>refresh</mat-icon>
                </button>
                <button
                  mat-icon-button
                  (click)="removeCustomDomain($event)"
                  [disabled]="isSavingDomain || isDeletingDomain"
                  [matTooltip]="'MySpace.CustomDomain.RemoveBtn' | translate"
                  class="text-gray-400 hover:text-red-600 hover:bg-red-50 flex items-center justify-center"
                >
                  <mat-icon>delete_outline</mat-icon>
                </button>
              }
            </div>
          </div>
        }

        <!-- Pending Domain Flow -->
        @if (customDomainData?.hasCustomDomain && customDomainData?.status !== 'active') {
          <div class="domain-pending-flow">
            <!-- Step 1: Domain Registered -->
            <div class="domain-step domain-step--done">
              <div class="domain-step__indicator">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <div class="domain-step__content">
                <h5 class="domain-step__title">{{ customDomainData?.customDomain }}</h5>
                @if (customDomainData?.status === 'cert_issued') {
                  <span class="domain-step__badge domain-step__badge--success">
                    <span class="domain-step__badge-dot"></span>
                    {{ 'MySpace.CustomDomain.StatusCertIssued' | translate }}
                  </span>
                } @else {
                  <span class="domain-step__badge domain-step__badge--pending">
                    <span class="domain-step__badge-dot"></span>
                    {{ 'MySpace.CustomDomain.StatusPending' | translate }}
                  </span>
                }
              </div>
              <div class="flex items-center gap-1 shrink-0">
                <button mat-icon-button btnType="action-icon" (click)="loadCustomDomainInfo()" [matTooltip]="'Global.Refresh' | translate" class="text-gray-400 hover:text-gray-600">
                  <mat-icon>refresh</mat-icon>
                </button>
                <button
                  mat-icon-button
                  btnType="action-icon"
                  (click)="removeCustomDomain($event)"
                  [disabled]="isSavingDomain || isDeletingDomain"
                  [matTooltip]="'MySpace.CustomDomain.RemoveBtn' | translate"
                  class="ms-2 flex items-center justify-center"
                >
                  @if (isDeletingDomain) {
                    <mat-spinner diameter="18"></mat-spinner>
                  } @else {
                    <mat-icon>delete_outline</mat-icon>
                  }
                </button>
              </div>
            </div>

            <!-- Step 2: DNS Configuration (CNAME) -->
            <div class="domain-step" [class.domain-step--done]="customDomainData?.status === 'cert_issued'" [class.domain-step--current]="customDomainData?.status === 'pending_dns'">
              <div class="domain-step__indicator" [class.domain-step__indicator--numbered]="customDomainData?.status !== 'cert_issued'">
                @if (customDomainData?.status === 'cert_issued') {
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                } @else {
                  2
                }
              </div>
              <div class="domain-step__content">
                <h5 class="domain-step__title flex items-center gap-1.5">
                  <mat-icon class="text-[16px]! h-[16px]! w-[16px]! text-[#5a73c5]">dns</mat-icon>
                  {{ 'MySpace.CustomDomain.DnsInstructionsTitle' | translate }}
                </h5>
                <p class="domain-step__desc">{{ 'MySpace.CustomDomain.DnsInstructionsDesc' | translate }}</p>

                <div class="domain-dns-record">
                  <div class="domain-dns-record__field">
                    <span class="domain-dns-record__label">{{ 'MySpace.CustomDomain.RecordType' | translate }}</span>
                    <span class="domain-dns-record__value">CNAME</span>
                  </div>
                  <div class="domain-dns-record__divider"></div>
                  <div class="domain-dns-record__field domain-dns-record__field--target">
                    <span class="domain-dns-record__label">{{ 'MySpace.CustomDomain.RecordTarget' | translate }}</span>
                    <span class="domain-dns-record__value domain-dns-record__value--primary">{{ customDomainData?.cnameTarget }}</span>
                  </div>
                  <button mat-icon-button btnType="action-icon" (click)="copyCnameTarget()" [matTooltip]="'Global.Copy' | translate" class="shrink-0">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>

                @if (customDomainData?.status !== 'cert_issued') {
                  <div class="domain-delay-hint">
                    <mat-icon class="domain-delay-hint__icon">schedule</mat-icon>
                    <p class="domain-delay-hint__text">{{ 'MySpace.CustomDomain.DelayHint' | translate }}</p>
                  </div>
                }
              </div>
            </div>

            <!-- Step 3: Apply SSL Certificate (Shown when cert_issued) -->
            @if (customDomainData?.status === 'cert_issued') {
              <div class="domain-step domain-step--current">
                <div class="domain-step__indicator domain-step__indicator--numbered">3</div>
                <div class="domain-step__content">
                  <h5 class="domain-step__title flex items-center gap-1.5">
                    <mat-icon class="text-[16px]! h-[16px]! w-[16px]! text-[#5a73c5]">verified_user</mat-icon>
                    {{ 'MySpace.CustomDomain.ApplyCertTitle' | translate }}
                  </h5>
                  <p class="domain-step__desc">{{ 'MySpace.CustomDomain.ApplyCertDesc' | translate }}</p>

                  <div class="mt-3">
                    <button mat-flat-button btnType="action" color="primary" (click)="applyCertificate()" [disabled]="isApplyingCert">
                      @if (isApplyingCert) {
                        <mat-icon class="mat-icon-spin">progress_activity</mat-icon>
                      }
                      <span>{{ 'MySpace.CustomDomain.ApplyCertBtn' | translate }}</span>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        <!-- Domain Setup Onboarding (shown when no domain is set) -->
        @if (!customDomainData?.hasCustomDomain) {
          <div class="domain-pending-flow">
            <!-- Pre-Step 1: Configure DNS at Registrar -->
            <div class="domain-step domain-step--current">
              <div class="domain-step__indicator domain-step__indicator--numbered">1</div>
              <div class="domain-step__content">
                <h5 class="domain-step__title flex items-center gap-1.5">
                  <mat-icon class="text-[16px]! h-[16px]! w-[16px]! text-[#5a73c5]">dns</mat-icon>
                  {{ 'MySpace.CustomDomain.PreStep1Title' | translate }}
                </h5>
                <p class="domain-step__desc">{{ 'MySpace.CustomDomain.PreStep1Desc' | translate }}</p>

                <div class="domain-dns-record">
                  <div class="domain-dns-record__field">
                    <span class="domain-dns-record__label">{{ 'MySpace.CustomDomain.RecordType' | translate }}</span>
                    <span class="domain-dns-record__value">CNAME</span>
                  </div>
                  <div class="domain-dns-record__divider"></div>
                  <div class="domain-dns-record__field domain-dns-record__field--target">
                    <span class="domain-dns-record__label">{{ 'MySpace.CustomDomain.RecordTarget' | translate }}</span>
                    <span class="domain-dns-record__value domain-dns-record__value--primary">{{ customDomainData?.cnameTarget || defaultCnameTarget }}</span>
                  </div>
                  <button mat-icon-button btnType="action-icon" (click)="copyCnameTarget()" [matTooltip]="'Global.Copy' | translate" class="shrink-0">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Pre-Step 2: Enter Custom Domain & Link -->
            <div class="domain-step">
              <div class="domain-step__indicator domain-step__indicator--numbered">2</div>
              <div class="domain-step__content">
                <h5 class="domain-step__title flex items-center gap-1.5">
                  <mat-icon class="text-[16px]! h-[16px]! w-[16px]! text-[#5a73c5]">link</mat-icon>
                  {{ 'MySpace.CustomDomain.PreStep2Title' | translate }}
                </h5>
                <p class="domain-step__desc">{{ 'MySpace.CustomDomain.PreStep2Desc' | translate }}</p>

                <div class="flex items-center gap-2 w-full mt-3">
                  <ui-input [(ngModel)]="customDomainInput" [placeholder]="'MySpace.CustomDomain.Placeholder' | translate" class="flex-1"></ui-input>
                  <button mat-flat-button btnType="action" color="primary" (click)="bindCustomDomain()" [disabled]="!customDomainInput || isSavingDomain || isLoadingDomain" class="shrink-0">
                    @if (isSavingDomain) {
                      <mat-icon class="mat-icon-spin">progress_activity</mat-icon>
                    } @else {
                      <mat-icon>verified</mat-icon>
                    }
                    <span>{{ 'MySpace.CustomDomain.VerifyLinkBtn' | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
